import { render, staticRenderFns } from "./appletcode.vue?vue&type=template&id=5ddc51ac&scoped=true"
import script from "./appletcode.vue?vue&type=script&lang=ts"
export * from "./appletcode.vue?vue&type=script&lang=ts"
import style0 from "./appletcode.vue?vue&type=style&index=0&id=5ddc51ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc51ac",
  null
  
)

export default component.exports